import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "card-header flex justify-between items-center" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "font-bold text-base" }, "Agencies", -1)
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" + Add ")
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { key: 1 }
const _hoisted_6 = { key: 2 }
const _hoisted_7 = { key: 3 }
const _hoisted_8 = { key: 4 }
const _hoisted_9 = /*#__PURE__*/_createTextVNode(" Active ")
const _hoisted_10 = /*#__PURE__*/_createTextVNode("Inactive")
const _hoisted_11 = /*#__PURE__*/_createTextVNode(" Select ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_FilterTable = _resolveComponent("FilterTable")!
  const _component_Delete = _resolveComponent("Delete")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_popconfirm = _resolveComponent("el-popconfirm")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_card = _resolveComponent("el-card")!
  const _component_el_link = _resolveComponent("el-link")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_el_tag = _resolveComponent("el-tag")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_el_card, { style: {"min-height":"500px"} }, {
      header: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _hoisted_2,
          _createVNode(_component_el_button, {
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.state.showModalAddAgency = true)),
            type: "primary",
            size: "small"
          }, {
            default: _withCtx(() => [
              _hoisted_3
            ]),
            _: 1
          })
        ])
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", null, [
          _createVNode(_component_FilterTable, {
            onOnFilterCallback: _ctx.onSearchSelectedAgencies,
            hidden: ""
          }, null, 8, ["onOnFilterCallback"]),
          _createVNode(_component_el_table, {
            data: _ctx.state.selectedAgencies,
            style: {"width":"100%"},
            stripe: "",
            "max-height": "400px"
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.state.columns, (column, index) => {
                return (_openBlock(), _createBlock(_component_el_table_column, {
                  key: index,
                  label: column.title,
                  props: column.dataIndex
                }, {
                  default: _withCtx((scope) => [
                    (column.dataIndex === 'email')
                      ? (_openBlock(), _createElementBlock("div", _hoisted_4, _toDisplayString(scope.row.manager.email), 1))
                      : _createCommentVNode("", true),
                    (column.dataIndex === 'action')
                      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                          _createVNode(_component_el_popconfirm, {
                            "confirm-button-text": "Yes",
                            "cancel-button-text": "No",
                            icon: _ctx.InfoFilled,
                            "icon-color": "red",
                            title: "Are you sure to delete this?",
                            onConfirm: ($event: any) => (_ctx.onDeleteAgency(scope.row))
                          }, {
                            reference: _withCtx(() => [
                              _createVNode(_component_el_button, {
                                size: "small",
                                type: "danger"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_el_icon, null, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_Delete)
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              })
                            ]),
                            _: 2
                          }, 1032, ["icon", "onConfirm"])
                        ]))
                      : (column.dataIndex === 'balance')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                            _createElementVNode("span", null, _toDisplayString(_ctx.formatterDollars(scope.row[column.dataIndex].amount)), 1)
                          ]))
                        : (column.dataIndex === 'updatedAt')
                          ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                              _createElementVNode("span", null, _toDisplayString(_ctx.formatDateTime(scope.row[column.dataIndex])), 1)
                            ]))
                          : (_openBlock(), _createElementBlock("span", _hoisted_8, _toDisplayString(scope.row[column.dataIndex]), 1))
                  ]),
                  _: 2
                }, 1032, ["label", "props"]))
              }), 128))
            ]),
            _: 1
          }, 8, ["data"])
        ])
      ]),
      _: 1
    }),
    _createVNode(_component_el_dialog, {
      modelValue: _ctx.state.showModalAddAgency,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.state.showModalAddAgency) = $event)),
      title: "Agency List",
      width: "60%"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_row, null, {
          default: _withCtx(() => [
            _createVNode(_component_el_col, {
              span: 24,
              class: ""
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_table, {
                  height: "500",
                  ref: "multipleTable",
                  data: _ctx.availableAgencies,
                  onSelectionChange: _ctx.handleSelectionChange,
                  stripe: "",
                  fit: ""
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_table_column, {
                      property: "name",
                      label: "Name"
                    }, {
                      default: _withCtx((scope) => [
                        _createVNode(_component_router_link, {
                          to: { path: `/a/agencies/${scope.row.id}` }
                        }, {
                          default: _withCtx(({ href }) => [
                            _createVNode(_component_el_link, {
                              type: "primary",
                              href: href
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(scope.row.name), 1)
                              ]),
                              _: 2
                            }, 1032, ["href"])
                          ]),
                          _: 2
                        }, 1032, ["to"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_table_column, {
                      property: "code",
                      label: "Code"
                    }),
                    _createVNode(_component_el_table_column, {
                      property: "manager",
                      label: "Email"
                    }, {
                      default: _withCtx((scope) => [
                        _createTextVNode(_toDisplayString(scope.row.manager.email), 1)
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_table_column, {
                      property: "createdAt",
                      label: "Created"
                    }, {
                      default: _withCtx((scope) => [
                        _createTextVNode(_toDisplayString(_ctx.fomartDate(scope.row.createdAt)), 1)
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_table_column, {
                      property: "active",
                      label: "Status"
                    }, {
                      default: _withCtx((scope) => [
                        (scope.row.active == 1)
                          ? (_openBlock(), _createBlock(_component_el_tag, {
                              key: 0,
                              type: "success"
                            }, {
                              default: _withCtx(() => [
                                _hoisted_9
                              ]),
                              _: 1
                            }))
                          : (_openBlock(), _createBlock(_component_el_tag, {
                              key: 1,
                              type: "danger"
                            }, {
                              default: _withCtx(() => [
                                _hoisted_10
                              ]),
                              _: 1
                            }))
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_table_column, {
                      property: "primaryDomain",
                      label: "Domain"
                    }),
                    _createVNode(_component_el_table_column, {
                      label: "Action",
                      width: ""
                    }, {
                      default: _withCtx((scope) => [
                        _createVNode(_component_el_button, {
                          onClick: ($event: any) => (_ctx.onAddAgency(scope.row)),
                          type: "primary"
                        }, {
                          default: _withCtx(() => [
                            _hoisted_11
                          ]),
                          _: 2
                        }, 1032, ["onClick"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["data", "onSelectionChange"])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}